import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiClient } from '../core/api-client.service';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { PendingNewsComponent } from './pending-news.component';
import { PendingNewsArticleComponent } from './pending-news-article.component';
import { EditNewsArticleModalComponent } from './Modals/edit-news-article-modal.component';
import { EditorModule } from '@tinymce/tinymce-angular';


@NgModule({
    declarations: [
        PendingNewsComponent,
        PendingNewsArticleComponent,
        EditNewsArticleModalComponent
    ],
    imports: [
        CommonModule
        , BrowserModule
        , FormsModule
        , ReactiveFormsModule
        , NgbPaginationModule
        , RouterModule
        , EditorModule
    ],
    providers: [ApiClient],
})
export class PendingNewsModule { }
